module.exports = __webpack_public_path__ + "static/fonts/Mont-ThinItalic.d3a2c32.woff2";